<template>
<div class="form-body">
  <div class="row">
    <div class="form-holder">
      <div class="form-content">
        <div class="form-items">
          <div>
            <div class="form-row newDesign">
                <span class="logo" style="width: 100%;" v-html="logos"></span>
                <span class="logo" style="width: 100%;" v-html="REGISTERATION_SUCCESS_ICON"></span>
                <p class="lead success-text-align" style="font-size:20px;text-align: center !important;"><strong>Thanks for Registering!</strong></p>
                <p class="lead success-sub-text-align">A verification email has been sent to you. Please click the activation link to confirm your account.</p>
                <hr class="complete">
                <h3 class="new_to_screenit success-sub-text-align">
                  Mail not received?
                  <span class="form-join-now cursor-usage " >Click here</span>
                </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div></div>
</template>

<script>
import { REGISTERATION_SUCCESS, logo } from '../../shared/svg'
import router from '../../router/index'

export default {
  name: 'registerationComplete',
  data () {
    return {
      REGISTERATION_SUCCESS_ICON: REGISTERATION_SUCCESS,
      logos: logo
    }
  },
  created () {
    const data = JSON.parse(localStorage.getItem('setPassword'))
    if (data === false || data === undefined) {
      router.push({ name: 'Login' })
    }
  }
}
</script>

<style scoped>
.form-holder {
  margin-left: 0px;
  width: 100%;
}
.success-text-align {
  width: 100%;
  font-weight: 400;
  letter-spacing: 0;
  color: #141414;
  opacity: 1;

}
.success-sub-text-align {
  width: 100%;
  height: 15px;
  letter-spacing: 0;
  color: #757575;
  opacity: 1;
  text-align: center !important;
  line-height: 16px;
  padding: 6px;
  margin-bottom: 15px;
}
hr.complete {
  border: 0.5px solid #757575;
  width: 100%;
}
.form-row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -5px;
  margin-left: -5px;
}
.form-content {
    width: 100%;
}
.form-content h3 {
  font-weight: 400 !important;
}
.form-items {
    margin-top: 2%;
}
.form-content .form-items {
    display: inline-block;
    width: 100%;
    max-width: 550px;
}
</style>
